
import EDMSDashboard from './edmsDashboard';

export default function EDMSHome() {
  return (
    <EDMSDashboard />
  );
};